import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase'

Vue.use(Vuex)

import Api from '@/providers/Api'

export default new Vuex.Store({
    state: {
        currentUserEmail: null,
        userIsAdmin: false,
        config: {},
        docs: [],

        docId: null,
        doc: null,
        docNotFound: false,
        tool: {},
        steps: [],
        currentStepIsValid: undefined,

        createFormLoading: false,
        deleteFormLoading: null
    },
    getters: {
        // generate a key for firebase RTDB (can't use '.' in keys)
        currentUserKey: (state) => {
            return state.currentUserEmail ? state.currentUserEmail.replace('.', '_dot_') : undefined
        },
    },
    mutations: {},
    actions: {
        // load list of user's docs
        loadDocs({commit}) {
            Api.loadDocs()
        },
        // load an individual doc
        loadDoc({commit}, payload) {
            Api.loadDoc(payload.docId)
        },
    },
    modules: {}
})
